import React from "react";
import Header from "./header";
import Footer from "./footer";

const TermsOfUse = () => {
  return (
    <div className="bg-gray-50 text-gray-800 font-sans">
      {/* Header */}
      <div className="w-full shadow-md sticky top-0 z-50">
        <Header />
      </div>

      {/* Main Content */}
      <div className="max-w-6xl mx-auto px-6 md:px-12 py-16">
        {/* Page Title */}
        <div className="text-center mb-5 mt-0">
          <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-700">
            Terms of Use
          </h1>

          <p className="mt-3 text-base md:text-lg text-slate-600 font-medium">
            Last updated:{" "}
            <span className="font-semibold text-slate-900">
              September 17, 2025
            </span>
          </p>

          {/* <p className="mt-3 text-base md:text-lg text-slate-600 font-medium">
            Last updated:{" "}
            <span className="font-semibold text-slate-900">
              {new Date().toLocaleDateString("en-IN", {
                year: "numeric",
                month: "long",
                day: "numeric",
                timeZone: "Asia/Kolkata",
              })}
            </span>
          </p> */}
        </div>

        {/* Sections */}
        <div className="space-y-4">
          {/* AGREEMENT */}
          <section className="bg-white rounded-2xl p-8 shadow-md border border-slate-200 hover:shadow-lg transition-all duration-300">
            <h2 className="text-xl md:text-2xl font-bold text-slate-900 mb-4 border-l-4 border-blue-600 pl-3">
              AGREEMENT BETWEEN USER AND COMPANY
            </h2>
            <p className="text-slate-700 text-base leading-relaxed mb-3">
              These Terms of Use ("Terms") constitute a legal agreement between
              you ("User" or "you") and the Company ("Company," "we," "us," or
              "our") regarding your use of the Company's platform, services,
              software applications, and related technology solutions
              (collectively, the "Services").
            </p>
            <p className="text-slate-700 text-base leading-relaxed mb-3">
              The Company platform is offered to you upon your unconditional
              acceptance of the terms set forth in this Agreement and any other
              terms and conditions that may apply to specific Services.
            </p>
            <p className="text-slate-700 text-base leading-relaxed">
              You acknowledge and agree that your use of the Company platform
              constitutes your unconditional acceptance of these Terms and our
              Privacy Policy.
            </p>
          </section>

          {/* MODIFICATION */}
          <section className="bg-white rounded-2xl p-8 shadow-md border border-slate-200 hover:shadow-lg transition-all duration-300">
            <h2 className="text-xl md:text-2xl font-bold text-slate-900 mb-4 border-l-4 border-blue-600 pl-3">
              MODIFICATION OF THESE TERMS OF USE
            </h2>
            <p className="text-slate-700 text-base leading-relaxed">
              The Company reserves the right to change the terms, conditions,
              and notices under which the Company Services are offered,
              including but not limited to the charges associated with the use
              of the Company Services. You are responsible for regularly
              reviewing these Terms of Use.
            </p>
          </section>

          {/* ACCEPTABLE USE */}
          <section className="bg-white rounded-2xl p-8 shadow-md border border-slate-200 hover:shadow-lg transition-all duration-300">
            <h2 className="text-xl md:text-2xl font-bold text-slate-900 mb-4 border-l-4 border-blue-600 pl-3">
              ACCEPTABLE USE POLICY
            </h2>
            <p className="text-slate-700 text-base leading-relaxed mb-3">
              As a user of the Company Services, you consent, understand, and
              warrant to the Company that you will not use the Company Services
              for any purpose that is unlawful or prohibited by these Terms of
              Use.
            </p>
            <p className="text-slate-700 text-base leading-relaxed mb-6">
              You agree not to use the Company Services in any way that could
              damage, disable, overburden, or impair the Company Services. You
              further agree that you shall{" "}
              <span className="font-semibold">NOT</span>:
            </p>
            <div className="space-y-4">
              {[
                "Upload or share content that infringes intellectual property rights.",
                "Post spam, chain letters, or unauthorized promotions.",
                "Spread malware, viruses, or harmful code.",
                "Manipulate identifiers to disguise content origin.",
                "Share content you do not have the legal right to distribute.",
              ].map((rule, idx) => (
                <div
                  key={idx}
                  className="bg-red-50 p-5 rounded-lg border-l-4 border-red-500 shadow-sm"
                >
                  <p className="text-slate-700 font-medium text-base">
                    • {rule}
                  </p>
                </div>
              ))}
            </div>
          </section>

          {/* REGISTRATION */}
          <section className="bg-white rounded-2xl p-8 shadow-md border border-slate-200 hover:shadow-lg transition-all duration-300">
            <h2 className="text-xl md:text-2xl font-bold text-slate-900 mb-4 border-l-4 border-blue-600 pl-3">
              REGISTRATION AND ACCOUNT SECURITY
            </h2>
            <p className="text-slate-700 leading-relaxed mb-3">
              To access certain features of the Company Services, you must
              register for an account. You agree to provide accurate and
              complete information, and to maintain its accuracy over time.
            </p>
            <p className="text-slate-700 leading-relaxed mb-3">
              You are responsible for maintaining the confidentiality of your
              password and all activities under your account.
            </p>
            <p className="text-slate-700 leading-relaxed">
              The Company will not be liable for any loss or damage caused by
              your failure to comply with this responsibility.
            </p>
          </section>

          {/* DESCRIPTION OF SERVICES */}
          <section className="bg-white rounded-2xl p-8 shadow-md border border-slate-200 hover:shadow-lg transition-all duration-300">
            <h2 className="text-xl md:text-2xl font-bold text-slate-900 mb-4 border-l-4 border-blue-600 pl-3">
              DESCRIPTION OF SERVICES
            </h2>
            <p className="text-slate-700 leading-relaxed mb-3">
              The Company provides innovative technology solutions and
              consulting services, including:
            </p>
            <ul className="list-disc list-inside text-slate-700 space-y-2 ml-4 mb-3">
              <li>Custom software development</li>
              <li>Cloud migration & infrastructure management</li>
              <li>Data analytics & machine learning solutions</li>
              <li>ERP and CRM systems</li>
              <li>Cybersecurity implementation</li>
              <li>Mobile & web app development</li>
              <li>DevOps consulting & CI/CD</li>
              <li>Technical support & training</li>
            </ul>
            <p className="text-slate-700 leading-relaxed">
              The Company may modify, suspend, or discontinue any aspect of the
              Services with prior notice where practicable.
            </p>
          </section>

          {/* USER CONTENT */}
          <section className="bg-white rounded-2xl p-8 shadow-md border border-slate-200 hover:shadow-lg transition-all duration-300">
            <h2 className="text-xl md:text-2xl font-bold text-slate-900 mb-4 border-l-4 border-blue-600 pl-3">
              USER CONTENT AND CONDUCT
            </h2>
            <p className="text-slate-700 leading-relaxed mb-3">
              You retain ownership of content you submit to the Services. By
              posting content, you grant the Company a license to use it solely
              for providing Services.
            </p>
            <div className="bg-yellow-50 p-4 rounded border-l-4 border-yellow-400">
              <h3 className="font-semibold text-slate-900 mb-2">
                Prohibited Activities
              </h3>
              <ul className="list-disc list-inside text-slate-700 space-y-1 ml-4">
                <li>Violate laws or third-party rights</li>
                <li>Harass, abuse, or discriminate</li>
                <li>Submit false or misleading info</li>
                <li>Spread malicious code</li>
                <li>Engage in spam or fraud</li>
              </ul>
            </div>
          </section>

          {/* INTELLECTUAL PROPERTY */}
          <section className="bg-white rounded-2xl p-8 shadow-md border border-slate-200 hover:shadow-lg transition-all duration-300">
            <h2 className="text-xl md:text-2xl font-bold text-slate-900 mb-4 border-l-4 border-blue-600 pl-3">
              INTELLECTUAL PROPERTY RIGHTS
            </h2>
            <p className="text-slate-700 leading-relaxed mb-3">
              The Services and all materials provided (software, graphics,
              trademarks, copyrights, etc.) are the exclusive property of the
              Company and licensors.
            </p>
            <p className="text-slate-700 leading-relaxed">
              You may not reproduce, distribute, reverse-engineer, or exploit
              the Services without prior written consent.
            </p>
          </section>

          {/* DATA PRIVACY */}
          <section className="bg-white rounded-2xl p-8 shadow-md border border-slate-200 hover:shadow-lg transition-all duration-300">
            <h2 className="text-xl md:text-2xl font-bold text-slate-900 mb-4 border-l-4 border-blue-600 pl-3">
              DATA PRIVACY AND SECURITY
            </h2>
            <p className="text-slate-700 leading-relaxed mb-3">
              We protect your personal data in compliance with Indian privacy
              laws, including the IT Act, 2000 and DPDP Act, 2023.
            </p>
            <div className="bg-green-50 p-4 rounded border-l-4 border-green-400">
              <h3 className="font-semibold text-slate-900 mb-2">
                Our Commitments
              </h3>
              <ul className="list-disc list-inside text-slate-700 space-y-1 ml-4">
                <li>No selling of personal data</li>
                <li>End-to-end encryption</li>
                <li>Compliance with Indian & global standards</li>
                <li>Data localization</li>
              </ul>
            </div>
          </section>

          {/* CONTACT INFO */}
          <section className="bg-white rounded-2xl p-8 shadow-md border border-slate-200 hover:shadow-lg transition-all duration-300">
            <h2 className="text-xl md:text-2xl font-bold text-slate-900 mb-4 border-l-4 border-blue-600 pl-3">
              CONTACT INFORMATION
            </h2>
            <div className="grid md:grid-cols-2 gap-8">
              <div className="p-6 bg-slate-50 rounded-lg border">
                <h3 className="text-lg font-semibold mb-3">General Inquiries</h3>
                <p className="text-sm">Anvitech Solutions</p>
                <p className="text-sm">
                  Email: admin@anvitechsolutions.com
                </p>
                <p className="text-sm">Phone: +91-8425930405</p>
              </div>
              <div className="p-6 bg-slate-50 rounded-lg border">
                <h3 className="text-lg font-semibold mb-3">Registered Office</h3>
                <p className="text-sm">Anvitech Solutions Private Limited</p>
                <p className="text-sm">
                  Office No. C-403, Hetal Arch premises, Malad West, Mumbai
                </p>
                <p className="text-sm">
                  Mumbai - 400064, Maharashtra, India
                </p>
              </div>
            </div>
          </section>

          {/* Closing Note */}
          <div className="text-center pt-10 border-t border-slate-200">
            <p className="text-slate-600 text-sm leading-relaxed">
              These Terms of Use are governed by Indian law and comply with the
              Information Technology Act, 2000, Digital Personal Data Protection
              Act, 2023, and Consumer Protection Act, 2019.
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="w-full bg-slate-100 border-t">
        <Footer />
      </div>
    </div>
  );
};

export default TermsOfUse;
